var render = function render(){
  var _this = this;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', {
    staticClass: "mb-1"
  }, [_c('b-col', {
    staticClass: "px-0",
    attrs: {
      "lg": "12",
      "md": "12",
      "sm": "12"
    }
  }, [_vm.$route.query.profile ? _c('div', {
    staticClass: "d-flex justify-content-between align-items-center top-div"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('router-link', {
    attrs: {
      "button": "",
      "to": "/profile"
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "arrow-left-short"
    }
  })], 1), _c('h5', [_c('b', [_vm._v(_vm._s(_vm.$t(_vm.getTranslationKey(_vm.$route.query.profile))))])])], 1), _c('button', {
    staticClass: "left",
    on: {
      "click": function () {
        return _this.$bvModal.show('bv-add-address');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("viewAddress.addAddress")) + " ")])]) : _c('h5', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.$t("viewAddress.title")))])])], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "bv-add-address",
      "size": "lg",
      "hide-footer": true,
      "hide-header": true,
      "no-close-on-esc": true,
      "no-close-on-backdrop": true,
      "centered": "",
      "header-class": "my-class",
      "body-class": "p-0"
    }
  }, [_vm.$options.components['address-add-address-modal'] ? [_c('address-add-address-modal')] : _vm._e()], 2), this.deliveryAddress.length !== 0 ? _c('b-row', {
    staticClass: "d-flex row-list"
  }, _vm._l(_vm.deliveryAddress, function (address, index) {
    return _c('b-col', {
      key: index,
      staticClass: "body mb-2",
      attrs: {
        "md": "6",
        "lg": "4",
        "sm": "12"
      }
    }, [_c('b-card-text', [_c('div', {
      staticClass: "d-flex justify-content-between"
    }, [_c('p', {
      staticClass: "heading-name",
      attrs: {
        "value": address
      }
    }, [_vm._v(" " + _vm._s(address.fullName) + " "), address.isDefault ? _c('large', {
      staticClass: "default-address-class ml-5"
    }, [_vm._v(" " + _vm._s(_vm.$t("viewAddress.default")) + " ")]) : _vm._e()], 1), _c('div', {}, [_vm.$store.state['address'].deleteAddressLoading != address._id ? _c('span', {
      staticClass: "float-right"
    }, [_c('img', {
      staticClass: "edit-icon-style",
      attrs: {
        "src": "img/EditIcon.png",
        "alt": ""
      },
      on: {
        "click": function () {
          _vm.editAddressClick(address);
          _vm.$bvModal.show(address._id);
        }
      }
    }), _c('img', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "src": "img/address/Trash.png",
        "alt": ""
      },
      on: {
        "click": function () {
          return _vm.deleteAddress(address._id);
        }
      }
    }), _c('b-modal', {
      attrs: {
        "id": address._id,
        "size": "lg",
        "hide-footer": true,
        "hide-header": true,
        "no-close-on-esc": true,
        "no-close-on-backdrop": true,
        "centered": "",
        "header-class": "my-class",
        "body-class": "p-0"
      }
    }, [_vm.$options.components['address-edit-address-modal'] ? [_c('address-edit-address-modal', {
      ref: "editAddressRef",
      refInFor: true,
      attrs: {
        "address": address
      }
    })] : _vm._e()], 2)], 1) : _vm._e(), _vm.$store.state['address'].deleteAddressLoading == address._id ? _c('span', {
      staticClass: "float-right"
    }, _vm._l(3, function (i) {
      return _c('b-spinner', {
        key: i,
        staticClass: "mr-1",
        attrs: {
          "small": "",
          "label": "Small Spinner",
          "type": "grow"
        }
      });
    }), 1) : _vm._e()])]), _c('div', {
      staticClass: "address-lines"
    }, [_c('p', {
      staticClass: "address-line"
    }, [_vm._v(" " + _vm._s(address.houseNumber) + ", " + _vm._s(address.street1) + " ")]), _c('p', {
      staticClass: "address-line"
    }, [_vm._v(" " + _vm._s(address.street2) + ", " + _vm._s(address.city) + " ")]), _c('p', {
      staticClass: "address-line"
    }, [_vm._v(_vm._s(address.state) + " - " + _vm._s(address.zip))])])])], 1);
  }), 1) : _vm._e(), this.deliveryAddress.length == 0 ? _c('p', {
    staticClass: "add-address text-center"
  }, [_vm._v(" " + _vm._s(_vm.$t("viewAddress.pleaseAddAddress")) + " ")]) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }